<template lang="pug">
div.field
  .control
    .select
      select(v-model="selected")
          option(v-for="cmp of companies", :value="cmp._id") {{cmp.name}}
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CompanyPicker",

  computed: {
    ...mapState(["company", "companies"]),
    selected: {
      get() {
        if (this.$store.state.company) {
          return this.$store.state.company._id;
        } else {
          return null;
        }
      },
      set(value) {
        const i = this.companies.map(c => c._id).indexOf(value);
        if (i >= 0) {
          this.$store.commit("company", this.companies[i]);
        } else {
          this.$store.commit("company", null);
          console.error("Selected company is not available - investigate.");
        }
      }
    }
  },
  props: {}
};
</script>

<style scoped lang="less">
</style>